import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EfetivoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(`/api/Efetivos/`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  /**
 * Cria um novo efetivo
 * @param efetivo
 * @returns Observable<any>
 */
  public store(efetivo: any): Observable<any> {
    return this.apiService.post(`/api/Efetivos/`, efetivo);
  }

  /**
* atualizar efetivo
* @param efetivo 
* @returns Observable<any>
*/
  public update(efetivo: any, id: string): Observable<any> {
    return this.apiService.put(`/api/Efetivos/${id}`, efetivo);
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/api/Efetivos/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  delete(id: number): Observable<any> {
    return this.apiService.delete(
      `/api/Efetivos/${id}`,
    )
  }

}